module.exports = "<select ng-model=\"ReportTypeFilterCtrl.reportType\">\n    <option\n        ng-repeat=\"type in ReportTypeFilterCtrl.reportTypes\"\n        value=\"{{type.value}}\"\n    >\n        {{type.display}}\n    </option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/filters/report-type/report-type-filter.html
// module id = 546
// module chunks = 0